import React, { Component } from 'react';
import { CustomIcon, CustomIconSet } from '@social-solutions/ssg-forms';

class AppointmentSplashPage extends Component {
    render() {
        return (
            <main className='splash-page-container'>
              <button
                id='closeDetailsButton'
                className='ssg-forms-icon-btn message-dismiss-btn'
                title="Dismiss"
                aria-label={'exit'}
                onClick={e => window.location.href = '/appointments'}>
                <CustomIcon iconChoice={CustomIconSet.ic_x_14x14} />
                Exit
              </button>
                <img className='sent-request-img' alt='appointment sent' src='/appointment-sent.png'/>
                <div className='splash-page-text'>
                  <span>Appointment Request Sent</span>
                  <p>Your request has been sent successfully and is currently awaiting confirmation.</p>
                </div>
                <div>
                  <button onClick={e => window.location.href='/appointments'} className='ssg-forms-btn ssg-forms-btn-secondary'>View Appointments</button>
                  <button onClick={e => window.location.href='/'} className='ssg-forms-btn ssg-forms-btn-primary'>Go to Dashboard</button>
                </div>
            </main>
        )
    }
}

export default AppointmentSplashPage;


// WEBPACK FOOTER //
// src/dashboard/appointments/appointment-splash-page.component.js